<template>
    <div class="message" :class="[type]" :style="{'max-width': massageWidth}" v-show="visible">
        <i v-if="type=='wait'" class="iconfont icon-jiazai loading"></i>
        <div class="message-content">
            {{message}}
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // 隐藏显示
            visible: false,
            message: '',
            onClose: null,
            closed: false,
            duration: 3000,
            timer: null,
            // 类型
            type: ''
        };
    },
    watch: {
        closed(newVal) {
            if (newVal) {
                this.visible = false;
                // eslint-disable-next-line
                clearTimeout(this.timer);
            }
        }
    },
    mounted() {
        if (this.type !== 'wait') {
            this.startTimer();
        }
    },
    methods: {
        close() {
            this.closed = true;
            if (typeof this.onClose === 'function') {
                this.onClose(this);
                // 删除dom
                this.$el.parentNode.removeChild(this.$el);
            }
        },
        startTimer() {
            if (this.duration > 0) {
                this.timer = setTimeout(() => {
                    if (!this.closed) {
                        this.close();
                    }
                }, this.duration);
            }
        }
    },
    computed: {
        massageWidth() {
            const ml = this.message.length;
            if (ml > 15) {
                return '270px';
            } else if (ml <= 4) {
                return `calc(5em + 30px)`;
            } else {
                return `calc(${ml + 1} * 4.3vw + 8vw)`;
            }
        }
    }
};
</script>

<style lang="less">
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';
.message {
    position: fixed;
    z-index: 5000;
    max-width: 80vw;
    min-width: 94 * @layout375;
    min-height: 44 * @layout375;
    padding: 10 * @layout375 15 * @layout375;
    top: 40vh;
    left: 0;
    right: 0;
    margin: auto;
    background-color: #000000;
    text-align: center;
    border-radius: 2 * @layout375;
    color: #ffffff;
    font-family: 'BlueSkyStandardRegular';

    .center();
    .message-content {
        font-size: 16 * @layout375;
        line-height: 24 * @layout375;
    }
    &.wait {
        display: flex;
        flex-direction: column;
        padding: 15 @layout375 0;
        // max-width: 7em;
        .loading {
            animation: loading 1s steps(12, end) infinite;
            margin-bottom: 10 * @layout375;
            font-size: 38 * @layout375;
        }
    }

    @keyframes loading {
        0% {
            transform: rotate3d(0, 0, 1, 360deg);
        }

        100% {
            transform: rotate3d(0, 0, 1, 0deg);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/marketing_components/message/message.vue